var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};























































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/* eslint-disable */

var warnings = {};

/**
 * @private
 */
function pipeUpdaters() {
  for (var _len = arguments.length, updaters = Array(_len), _key = 0; _key < _len; _key++) {
    updaters[_key] = arguments[_key];
  }

  if (!warnings.pipeUpdaters) {
    warnings.pipeUpdaters = true;
    console.warn('Warning: pipeUpdaters(...updaters) is deprecated. Use concat(...updaters)');
  }

  return function (current) {
    return function (previous) {
      return updaters.reduce(function (p, r) {
        return r(current)(p);
      }, previous);
    };
  };
}

function anyOf() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.reduce(function (c, n) {
    return !!c || !!n();
  }, false);
}

/**
 * @private
 */
function filterUpdater(predicate, leftUpdater, rightUpdater) {
  if (!warnings.filterUpdater) {
    warnings.filterUpdater = true;
    console.warn('Warning: filterUpdater(predicate, leftUpdater, rightUpdater) is deprecated. Use match(predicateUpdater, leftUpdater, rightUpdater)');
  }

  if (leftUpdater == null) {
    return function (leftUpdater) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      return filterUpdater.apply(undefined, [predicate, leftUpdater].concat(rest));
    };
  }

  if (rightUpdater == null) {
    return filterUpdater(predicate, leftUpdater, function () {
      return function (s) {
        return s;
      };
    });
  }

  var doesMatch = function doesMatch(predicate) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var state = arguments[2];

    if (typeof predicate === 'string') return predicate === action.type;

    if (Array.isArray(predicate)) return anyOf.apply(undefined, toConsumableArray(predicate.map(function (p) {
      return function () {
        return doesMatch(p, action, state);
      };
    })));

    return Boolean(predicate(action, state));
  };

  return function (action) {
    return function (state) {
      if (leftUpdater != null && rightUpdater != null) return doesMatch(predicate, action, state) ? leftUpdater(action)(state) : rightUpdater(action)(state);
    };
  };
}

/**
 * @private
 */
function createUpdater(actionMap) {
  if (!warnings.createUpdater) {
    warnings.createUpdater = true;
    console.warn('Warning: createUpdater(actionMap) is deprecated. Use handleActions(actionTypeUpdaterMap)');
  }
  var updaters = Object.keys(actionMap).map(function (actionType) {
    return filterUpdater(actionType, actionMap[actionType]);
  });

  return pipeUpdaters.apply(undefined, toConsumableArray(updaters));
}

/**
 * Set a value by a dot path.
 * @param obj The object to evaluate.
 * @param prop The path to be set.
 * @param val The value to set.
 */

var set$1 = function set$$1(obj, prop, value) {
	prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

	var setPropImmutableRec = function setPropImmutableRec(obj, prop, value, i) {
		var clone,
		    head = prop[i];

		if (prop.length > i) {
			if (Array.isArray(obj)) {
				head = getArrayIndex(head, obj);
				clone = obj.slice();
			} else {
				clone = Object.assign({}, obj);
			}
			clone[head] = setPropImmutableRec(obj[head] !== undefined ? obj[head] : {}, prop, value, i + 1);
			return clone;
		}

		return typeof value === 'function' ? value(obj) : value;
	};

	return setPropImmutableRec(obj, prop, value, 0);
};

/**
 * Get a value by a dot path.
 * @param obj The object to evaluate.
 * @param prop The path to value that should be returned.
 */
var get$1 = function get$$1(obj, prop) {
	prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

	for (var i = 0; i < prop.length; i++) {
		if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
			return undefined;
		}
		var head = prop[i];
		if (Array.isArray(obj) && head === '$end') {
			head = obj.length - 1;
		}
		obj = obj[head];
	}

	return obj;
};

/**
 * Delete a property by a dot path.
 * If target container is an object, the property is deleted.
 * If target container is an array, the index is deleted.
 * If target container is undefined, nothing is deleted.
 * @param obj The object to evaluate.
 * @param prop The path to the property or index that should be deleted.
 */
var delete_1 = function delete_1(obj, prop) {
	prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

	var deletePropImmutableRec = function deletePropImmutableRec(obj, prop, i) {
		var clone,
		    head = prop[i];

		if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !Array.isArray(obj) && obj[head] === undefined || Array.isArray(obj) && obj[getArrayIndex(head, obj)] === undefined) {

			return obj;
		}

		if (prop.length - 1 > i) {
			if (Array.isArray(obj)) {
				head = getArrayIndex(head, obj);
				clone = obj.slice();
			} else {
				clone = Object.assign({}, obj);
			}

			clone[head] = deletePropImmutableRec(obj[head], prop, i + 1);
			return clone;
		}

		if (Array.isArray(obj)) {
			head = getArrayIndex(head, obj);
			clone = [].concat(obj.slice(0, head), obj.slice(head + 1));
		} else {
			clone = Object.assign({}, obj);
			delete clone[head];
		}

		return clone;
	};

	return deletePropImmutableRec(obj, prop, 0);
};

/**
 * Toggles a value.  The target value is evaluated using Boolean(currentValue).  The result will always be a JSON boolean.
 * Be careful with strings as target value, as "true" and "false" will toggle to false, but "0" will toggle to true.
 * Here is what Javascript considers false:  0, -0, null, false, NaN, undefined, and the empty string ("")
 * @param obj The object to evaluate.
 * @param prop The path to the value.
 */
var toggle = function toggle(obj, prop) {
	var curVal = this.get(obj, prop);
	return this.set(obj, prop, !Boolean(curVal));
};

/**
 * Merges a value.  The target value must be an object, array, null, or undefined.
 * If target is an object, Object.assign({}, target, param) is used.
 * If target an array, target.concat(param) is used.
 * If target is null or undefined, the value is simply set.
 * @param obj The object to evaluate.
 * @param prop The path to the value.
 * @param val The value to merge into the target value.
 */
var merge = function merge(obj, prop, val) {
	var curVal = this.get(obj, prop);
	if ((typeof curVal === 'undefined' ? 'undefined' : _typeof(curVal)) === 'object') {
		if (Array.isArray(curVal)) {
			return this.set(obj, prop, curVal.concat(val));
		} else if (curVal === null) {
			return this.set(obj, prop, val);
		} else {
			var merged = Object.assign({}, curVal, val);
			return this.set(obj, prop, merged);
		}
	} else if (typeof curVal === 'undefined') {
		return this.set(obj, prop, val);
	} else {
		return obj;
	}
};

function getArrayIndex(head, obj) {
	if (head === '$end') {
		head = obj.length - 1;
	}
	if (!/^\+?\d+$/.test(head)) {
		throw new Error('Array index \'' + head + '\' has to be an integer');
	}
	return parseInt(head);
}

function propToArray(prop) {
	return prop.replace(/\\\./g, '@').replace(/\./g, '*').replace(/@/g, '.').split('*');
}

var index = {
	set: set$1,
	get: get$1,
	delete: delete_1,
	toggle: toggle,
	merge: merge
};

function unwrapExports (x) {
	return x && x.__esModule ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _0 = function _0(fn) {
  return function () {
    return fn.apply(null, arguments);
  };
};

var _1 = function _1(fn) {
  return function (a) {
    return fn.apply(null, arguments);
  };
};

var _2 = function _2(fn) {
  return function (a, b) {
    return fn.apply(null, arguments);
  };
};

var _3 = function _3(fn) {
  return function (a, b, c) {
    return fn.apply(null, arguments);
  };
};

var _4 = function _4(fn) {
  return function (a, b, c, d) {
    return fn.apply(null, arguments);
  };
};

var _5 = function _5(fn) {
  return function (a, b, c, d, e) {
    return fn.apply(null, arguments);
  };
};

var arityFn = [_0, _1, _2, _3, _4, _5];

var N = function N(fn, n) {
  if (n && n <= 5) {
    return arityFn[n](fn);
  } else {
    return fn;
  }
};

var index$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports['default'] = compose;
  // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { 'default': obj };
  }

  var _arityN = N;

  var _arityN2 = _interopRequireDefault(_arityN);

  var compose2 = function compose2(f, g) {
    return function () {
      return f(g.apply(undefined, arguments));
    };
  };

  function compose() {
    for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
      functions[_key] = arguments[_key];
    }

    var funcs = functions.filter(function (fn) {
      return typeof fn === 'function';
    });

    var lastIdx = funcs.length - 1;
    var arity = 0;

    if (funcs.length <= 0) {
      throw new Error('No funcs passed');
    }

    if (lastIdx >= 0 && funcs[lastIdx]) {
      arity = funcs[lastIdx].length;
    }

    return (0, _arityN2['default'])(funcs.reduce(compose2), arity);
  }

  module.exports = exports['default'];
});

var compose = unwrapExports(index$1);

var warning = {};

/**
 * **Syntax**
 * ```javascript
 * match(predicateUpdater, leftUpdater)
 * ```
 *
 * ```javascript
 * match(predicateUpdater, leftUpdater, rightUpdater)
 * ```
 *
 * ```javascript
 * match(predicateUpdater)(leftUpdater)
 * ```
 *
 * ```javascript
 * match(predicateUpdater)(leftUpdater, rightUpdater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * - calls **`leftUpdater`** if `predicateUpdater` returns true, or
 * - calls **`rightUpdater`** if `predicateUpdater` returns false and `rightUpdater` is defined, or
 * - returns the state unchanged if `predicateUpdater` returns false and `rightUpdater` is undefined.
 *
 * @example
 * match(p, t, f)
 * // Is equivalent to
 * action => state => p(action)(state) ? t(action)(state) : f(action)(state)
 *
 * @example
 * match(p, t)
 * // Is equivalent to
 * action => state => p(action)(state) ? t(action)(state) : state
 */
var match = function match(predicateUpdater, leftUpdater, rightUpdater) {
  if (leftUpdater !== undefined) {
    return function (action) {
      return function (state) {
        return predicateUpdater(action)(state) ? leftUpdater(action)(state) : rightUpdater !== undefined ? rightUpdater(action)(state) : state;
      };
    };
  }

  return function (leftUpdater, rightUpdater) {
    return match(predicateUpdater, leftUpdater, rightUpdater);
  };
};

/**
 * **Syntax**
 * ```javascript
 * withDefaultState(defaultState, updater)
 * ```
 *
 * ```javascript
 * withDefaultState(defaultState)(updater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * calls `updater` with `defaultState` if incoming state is undefined, or calls it with the incoming state.
 * @example
 * withDefaultState(0, add)
 * // Is equivalent to
 * action => (state = 0) => add(action)(state)
 */
var withDefaultState = function withDefaultState(defaultState, updater) {
  if (updater !== undefined) {
    return match(function () {
      return function (state) {
        return state === undefined;
      };
    })(function (action) {
      return function () {
        return updater(action)(defaultState);
      };
    }, updater);
  }

  return function (updater) {
    return withDefaultState(defaultState, updater);
  };
};

/**
 * **Syntax**
 * ```javascript
 * concat(...updaters)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * calls each updater with the preceding updater's outgoing state (left-to-right).
 * @param {...Updater} updaters
 * @example
 * concat(f, g, h)
 * // Is equivalent to
 * action => state => h(action)(g(action)(f(action)(state)))
 */
var concat = function concat() {
  for (var _len = arguments.length, updaters = Array(_len), _key = 0; _key < _len; _key++) {
    updaters[_key] = arguments[_key];
  }

  return function (action) {
    return function (state) {
      return updaters.reduce(function (s, updater) {
        return updater(action)(s);
      }, state);
    };
  };
};

/**
 * **Syntax**
 * ```javascript
 * combine(pathFragmentUpdaterMap)
 * ```
 *
 * **Description**
 *
 * Like [`combineReducers`](http://redux.js.org/docs/api/combineReducers.html), but for updaters.
 *
 * @example
 * combine({
 *   foo: fooUpdater,
 *   bar: barUpdater
 * })
 * // Is equivalent to
 * concat(
 *   updateStateAt('foo', fooUpdater),
 *   updateStateAt('bar', barUpdater)
 * )
 *
 */
var combine = function combine(pathFragmentUpdaterMap) {
  return withDefaultState({}, concat.apply(undefined, toConsumableArray(Object.keys(pathFragmentUpdaterMap).map(function (k) {
    return updateStateAt(k, pathFragmentUpdaterMap[k]);
  }))));
};

/**
 * @private
 */
var combineUpdaters = function combineUpdaters() {
  if (!warning.combineUpdaters) {
    warning.combineUpdaters = true;
    // eslint-disable-next-line
    console.warn('Warning: combineUpdaters(pathMap) is deprecated. Use combine(pathFragmentUpdaterMap)');
  }
  return combine.apply(undefined, arguments);
};

/**
 * **Syntax**
 * ```javascript
 * handleAction(actionType, updater)
 * ```
 *
 * ```javascript
 * handleAction(actionType)(updater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * calls `updater` if `actionType` matches incoming action's type, or returns the state unchanged.
 * @example
 * handleAction('SOME_ACTION', someUpdater)
 * // Is equivalent to
 * match(action => () => action.type === 'SOME_ACTION', someUpdater)
 */
var handleAction = function handleAction(actionType, updater) {
  if (updater !== undefined) {
    return match(function (action) {
      return function () {
        return (typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' && action != null && action.type === actionType;
      };
    }, updater);
  }

  return function (updater) {
    return handleAction(actionType, updater);
  };
};

/**
 * **Syntax**
 * ```javascript
 * handleActions(actionTypeUpdaterMap)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * delegates to a matching updater from `actionTypeUpdaterMap` based on the incoming action's type, or returns the state unchanged.
 *
 *
 * @example
 * handleActions({
 *   ACTION_ONE: updaterOne,
 *   ACTION_TWO: updaterTwo
 * })
 * // Is equivalent to
 * concat(
 *   handleAction('ACTION_ONE', updaterOne),
 *   handleAction('ACTION_TWO', updaterTwo)
 * )
 */
var handleActions = function handleActions(actionTypeUpdaterMap) {
  return concat.apply(undefined, toConsumableArray(Object.keys(actionTypeUpdaterMap).map(function (k) {
    return handleAction(k, actionTypeUpdaterMap[k]);
  })));
};

/**
 * **Syntax**
 * ```javascript
 * updateStateAt(path, updater)
 * ```
 *
 * ```javascript
 * updateStateAt(path)(updater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * calls `updater` with incoming state focused at `path`, then merges the result into outgoing state.
 *
 *
 * @example
 * const updater = updateStateAt('a.b', () => state => state + 1)
 * const state = { a: { b: 1 }, c: 0 }
 *
 * updater()(state)
 * // Result: `{ a: { b: 2 }, c: 0 }`
 */
var updateStateAt = function updateStateAt(path, updater) {
  if (updater !== undefined) {
    return function (action) {
      return function (state) {
        return index.set(state, path, function (v) {
          if (index.get(state, path) !== undefined) {
            return updater(action)(v);
          }
          return updater(action)(undefined);
        });
      };
    };
  }

  return function (updater) {
    return updateStateAt(path, updater);
  };
};

/**
 * **Syntax**
 * ```javascript
 * mapState(updater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * maps incoming state via `updater` as iteratee.
 *
 * @example
 * mapState(action => state => state + action)
 * // Is equivalent to
 * action => state => state.map(item => item + action)
 */
var mapState = function mapState(updater) {
  return function (action) {
    return function (state) {
      return state.map(updater(action));
    };
  };
};

/**
 * **Syntax**
 * ```javascript
 * filterState(updater)
 * ```
 *
 * **Description**
 *
 * Creates a proxy updater that:
 *
 * filters incoming state via `updater` as predicate.
 * @example
 * filterState(action => state => action > state)
 * // Is equivalent to
 * action => state => state.filter(item => action > item)
 */
var filterState = function filterState(updater) {
  return function (action) {
    return function (state) {
      return state.filter(updater(action));
    };
  };
};

/**
 * **Syntax**
 * ```javascript
 * constantState(value)
 * ```
 *
 * **Description**
 *
 * Creates an updater that always returns `value`.
 * @example
 * constantState('foo')
 * // Is equivalent to
 * () => () => 'foo'
*/
var constantState = function constantState(value) {
  return function () {
    return function () {
      return value;
    };
  };
};

/**
 * **Syntax**
 * ```javascript
 * decorate(...fns, value)
 * ```
 *
 * **Description**
 *
 * Applies to `value` a function created by composing `...fns`.
 *
 * @example
 * decorate(f, g, h, value)
 * // Is equivalent to
 * f(g(h(value)))
 * @example
 * decorate(
 *   withDefaultState(0),
 *   handleAction('ADD'),
 *   action => state => state + action.payload
 * )
 * // Is equivalent to
 * withDefaultState(0, handleAction('ADD', action => state => state + action.payload))
 * @param {...Function} fns
 * @param {any} value
 * @returns {any}
*/
var decorate = function decorate() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  var value = fns.slice(-1)[0];
  fns = fns.slice(0, -1);

  if (fns.length === 0) {
    return value;
  }

  return compose.apply(undefined, toConsumableArray(fns))(value);
};

/**
 * Action-first curried reducer.
 */

export { match, withDefaultState, concat, combine, combineUpdaters, handleAction, handleActions, updateStateAt, mapState, filterState, constantState, decorate, pipeUpdaters, filterUpdater, createUpdater };
//# sourceMappingURL=redux-fp.mjs.map
